import { Navigate, useLocation } from 'react-router-dom';

import useStateHandler from '@/hooks/useStateHandler';
import AddArticleForm from '@/shared-components/forms/add-board-content/add-article';
import { canAccessGalleryPermission } from '@/utils/galleryPermissions';

export default function AddArticle() {
  const location = useLocation();
  const { state } = useStateHandler();
  const session = state.user_session;
  const publishedPost = location.state?.publishedData; // wherever you actually stash the loaded post
  const canCreateArticle = !session?.gallery_id
    || canAccessGalleryPermission(session, "board.article", session?.gallery_id);

  if (!canCreateArticle) {
    return <Navigate to="/profile/board" replace />;
  }

  return (
    <>
      <AddArticleForm
        postData={publishedPost}
        editMode={!!publishedPost}
      />
    </>
  );
}
